import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment.prod';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
//http://192.168.43.119:8000/api/home
  constructor(private httpClient: HttpClient) {
  }

  getHome(): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/home`);
  }
  advanceSearch(data): Observable<any> {
    return this.httpClient.post<any>(`${environment.endpoint}/api/advance_search`,data);
  }
  simpleSearch(data): Observable<any> {
    //search
    return this.httpClient.post<any>(`${environment.endpoint}/api/simple_search`,data);
  }
  Newsletter(data): Observable<any> {
    return this.httpClient.post<any>(`${environment.endpoint}/api/news_request`,data);
  }
  products(): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/catalogs`);
  }
}
